import UploadBulk from './UploadBulk.component';

export default UploadBulk;
